import { makeAutoObservable } from 'mobx'

import { KyrgyzstanSearchPresetsApi } from 'shared/api/kyrgyzstan/search-presets'
import { getApiErrorMessage } from 'shared/lib/errorText'

import type { KyrgyzstanRestPlace } from './types'

class KyrgyzstanRestPlacesStore {
  items: KyrgyzstanRestPlace[] = []
  title: string | null = null
  isLoading = false
  error: string | null = null
  isLoaded = false

  constructor() {
    makeAutoObservable(this)
  }

  getRestPlaces() {
    return this.items
  }

  getTitle() {
    return this.title
  }

  async load() {
    if (this.isLoading) {
      return
    }

    this.isLoading = true
    this.error = null

    try {
      const { data: response } = await KyrgyzstanSearchPresetsApi.getPresets()
      this.title = response.data.title
      this.items = response.data.presets
      this.isLoaded = true
    } catch (error: unknown) {
      this.error = getApiErrorMessage(error)
      this.items = []
      this.title = null
      this.isLoaded = true
    } finally {
      this.isLoading = false
    }
  }

  loadIfNeeded() {
    if (this.isLoaded || this.isLoading) {
      return
    }

    void this.load()
  }
}

export const kyrgyzstanRestPlacesStore = new KyrgyzstanRestPlacesStore()
